<mat-tab-group class="review-sol-tabs" [(selectedIndex)]="selectedTabIndex">
   @if(readOnlyMode) {
   <mat-tab label="{{'REVIEW_SOL_TABS_LABELS.HOURS_TASKS' | translate}}">
      <ng-template matTabContent>
         <app-hoursandtasks (disablePdf)="onDisablePdf($event)"></app-hoursandtasks>
      </ng-template>
   </mat-tab>
}
  
   <mat-tab label="{{'REVIEW_SOL_TABS_LABELS.LABOR_AND_COSTS' | translate}}">
      <ng-template matTabContent>
         <app-sol-costs-labor-tab (disablePdf)="onDisablePdf($event)"></app-sol-costs-labor-tab>
      </ng-template>
   </mat-tab>

   @if(readOnlyMode) {
   <mat-tab label="{{'REVIEW_SOL_TABS_LABELS.OT_PWR' | translate}}">
      <ng-template matTabContent>
         <app-sol-overtime-prevailing-wage (disablePdf)="onDisablePdf($event)"></app-sol-overtime-prevailing-wage>
      </ng-template>
   </mat-tab>
}
  
   <mat-tab label="{{'REVIEW_SOL_TABS_LABELS.SUMMARY' | translate}}">
      <ng-template matTabContent>
         <app-sol-summary-tab (disablePdf)="onDisablePdf($event)"></app-sol-summary-tab>
      </ng-template>
   </mat-tab>

   @if(readOnlyMode) {
   <mat-tab label="{{'REVIEW_SOL_TABS_LABELS.MATERIAL' | translate}}">
      <ng-template matTabContent>
         <app-sol-material (disablePdf)="onDisablePdf($event)"></app-sol-material>
      </ng-template>
   </mat-tab>
}
   @if(readOnlyMode) {
   <mat-tab label="{{'REVIEW_SOL_TABS_LABELS.RISK' | translate}}">
      <ng-template matTabContent>
         <app-sol-risk (disablePdf)="onDisablePdf($event)"></app-sol-risk>
      </ng-template>
   </mat-tab>
}
   @if(readOnlyMode) {
   <mat-tab label="{{'REVIEW_SOL_TABS_LABELS.SUBS_MISC' | translate}}">
      <ng-template matTabContent>
         <app-sol-subcontractors (disablePdf)="onDisablePdf($event)"></app-sol-subcontractors>
      </ng-template>
   </mat-tab>
}
 
   <mat-tab label="{{'REVIEW_SOL_TABS_LABELS.POLICY_EXCEPTIONS' | translate}}">
      <ng-template matTabContent>
         <app-sol-policy-exception-tab (disablePdf)="onDisablePdf($event)"></app-sol-policy-exception-tab>
      </ng-template>
   </mat-tab>

  
   <mat-tab label="{{'REVIEW_SOL_TABS_LABELS.MARGINS' | translate}}">
      <ng-template matTabContent>
         <app-sol-margins-tab (disablePdf)="onDisablePdf($event)"></app-sol-margins-tab>
      </ng-template>
   </mat-tab>

   @if(isConditionsTabVisible) {
      <mat-tab label="{{'REVIEW_SOL_TABS_LABELS.CONDITIONS' | translate}}">
         <ng-template matTabContent>
            <app-sol-conditions-tab (disablePdf)="onDisablePdf($event)"></app-sol-conditions-tab>
         </ng-template>
      </mat-tab>
   }
 
   <mat-tab label="{{'REVIEW_SOL_TABS_LABELS.BID_DOCUMENTATION' | translate}}">
      <ng-template matTabContent>
         <app-sol-bid-documentation-tab (disablePdf)="onDisablePdf($event)"></app-sol-bid-documentation-tab>
      </ng-template>
   </mat-tab>

  
   <mat-tab label="{{'REVIEW_SOL_TABS_LABELS.CONTRACTUAL_DOCUMENTATION' | translate}}">
      <ng-template matTabContent>
         <app-sol-contractual-tab (disablePdf)="onDisablePdf($event)"></app-sol-contractual-tab>
      </ng-template>
   </mat-tab>

  @if(isPMRequirementTabVisible) {
   <mat-tab label="{{'REVIEW_SOL_TABS_LABELS.PM_REQUIREMENTS' | translate}}">
         <ng-template matTabContent>
            <app-sol-pm-requirements-tab (disablePdf)="onDisablePdf($event)"></app-sol-pm-requirements-tab>
         </ng-template>
      </mat-tab>
  }
 

   @if(readOnlyMode) {
   <mat-tab label="{{'REVIEW_SOL_TABS_LABELS.OTHER' | translate}}">
      <ng-template matTabContent>
         <app-sol-other-tab (disablePdf)="onDisablePdf($event)"></app-sol-other-tab>
      </ng-template>
   </mat-tab>
}
   
   <mat-tab label="{{'REVIEW_SOL_TABS_LABELS.CATCH_ALL' | translate}}">
      <ng-template matTabContent>
         <app-sol-complete-checklist-tab></app-sol-complete-checklist-tab>
      </ng-template>
   </mat-tab>

</mat-tab-group>